<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2024-03-14 16:25:47
 * @Description: 
 * @LastEditors: fengxiaojing
-->
<template>
  <div
    class="h-full p-10px absolute text-white z-99 w-468px rounded-2px right-35px"
    :style="{
      height: location.height,
      top: location.top,
      right: location.float === 'right' ? '25px' : '',
      left: location.float === 'left' ? '25px' : '',
    }"
    id="EngineeringAnimationConfig"
  >
    <el-row class="mb-10px">
      <el-col :span="21">
        <span class="text-14px">工程动画配置</span>
      </el-col>
      <el-col :span="3" class="text-right">
        <span
          class="iconfont float-right cursor-pointer icon-line-close text-12px"
          @click="closeComponent"
        ></span>
      </el-col>
    </el-row>
    <div
      class="form_body mt-10px text-white w-full h-[calc(100%-50px)] overflow-y-auto pt-10px pr-5px pb-10px pl-5px"
    >
      <el-row :gutter="20" class="mt-10px">
        <el-col :span="12" :offset="0" class="text-14px">
          是否自动播放
        </el-col>
        <el-col :span="12" :offset="0">
          <el-switch size="small" v-model="animationConfig.autoPlay" @change="changeAnimationAuto">
          </el-switch>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mt-10px">
        <el-col :span="12" :offset="0" class="text-14px">
          是否循环
        </el-col>
        <el-col :span="12" :offset="0">
          <el-switch
            size="small"
            v-model="animationConfig.playTimes"
            @change="changeAnimationTimes"
          >
          </el-switch>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mt-10px">
        <el-col :span="12" :offset="0" class="text-14px">
          默认动画速度
        </el-col>
        <el-col :span="12" :offset="0">
          <el-select
            size="small"
            v-model="animationConfig.speed"
            filterable
            @change="changeAnimationSpeed"
            popper-class="document_select-popper"
          >
            <el-option
              v-for="item in speedOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { find } from 'lodash'
import { loadModel, isJSONObj, generateGUID, EnumObjectTypes } from '../../assets/js/scene/scene'
export default {
  name: 'EngineeringAnimationConfig',
  props: ['location', 'player'],
  data() {
    return {
      speedOption: [
        {
          value: 0.1,
          label: '0.1X',
        },
        {
          value: 0.2,
          label: '0.2X',
        },
        {
          value: 0.5,
          label: '0.5X',
        },
        {
          value: 1,
          label: '1X',
        },
        {
          value: 2,
          label: '2X',
        },
        {
          value: 4,
          label: '4X',
        },
        {
          value: 8,
          label: '8X',
        },
        {
          value: 16,
          label: '16X',
        },
      ],
      animationConfig: {
        autoPlay: true,
        speed: 1,
        playTimes: true,
      },
      fileList: [],
      currentNode: null,
    }
  },
  computed: {},
  async created() {
    this.checkEngineerLoad()
  },
  methods: {
    async checkEngineerLoad() {
      const rootItem = await this.player.Native.ModelTree.getRootItems()
      // 在跟节点集合中查找我们设置的场景的跟节点
      const rootNode = find(rootItem, (val) => {
        return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'Root'
      })
      const modelChildren = await this.player.Native.NodeProxy.getNodeChildren(rootNode.nodePtr)
      const modelChild = find(modelChildren, (item) => {
        return item.code && isJSONObj(item.code) && JSON.parse(item.code).type === 'engineering'
      })
      if (modelChild) {
        this.currentNode = modelChild.nodePtr
        this.animationConfig = JSON.parse(modelChild.code).animationConfig
        this.fileList = JSON.parse(modelChild.code).fileList
      } else {
        this.$message.warning('工程模型未加载')
        this.closeComponent()
      }
    },
    async changeAnimationAuto(value) {
      const animationGroup = await this.player.Native.AnimationMgr.hasGroup('pprjAnimation')
      if (!animationGroup) {
        this.animationConfig.autoPlay = !value
        this.$message.warning('当前未添加工程')
        return
      }
      if (value) {
        await this.player.Native.AnimationMgr.start(animationGroup)
      } else {
        await this.player.Native.AnimationMgr.stop(animationGroup)
      }
      this.setNodeCode()
    },
    async changeAnimationTimes(value) {
      const animationGroup = await this.player.Native.AnimationMgr.hasGroup('pprjAnimation')
      if (!animationGroup) {
        this.animationConfig.playTimes = !value
        this.$message.warning('当前未添加工程')
        return
      }
      await this.player.Native.AnimationMgr.setLoop(animationGroup, value)
      if (this.animationConfig.autoPlay) {
        await this.player.Native.AnimationMgr.start(animationGroup)
      }
      this.setNodeCode()
    },
    async changeAnimationSpeed(value) {
      const animationGroup = await this.player.Native.AnimationMgr.hasGroup('pprjAnimation')
      if (!animationGroup) {
        this.animationConfig.speed = 1
        this.$message.warning('当前未添加工程')
        return
      }
      await this.player.Native.AnimationMgr.setSpeed(animationGroup, value)
      this.setNodeCode()
    },
    async setNodeCode() {
      const uuid = generateGUID()
      const currentFileData = find(this.fileList, ['type', 'engineering'])
      if (this.currentNode) {
        const codeInfo = {
          id: uuid,
          type: 'engineering',
          filePath: currentFileData.targetUrl,
          modelFileId: currentFileData.fileId,
          animationConfig: this.animationConfig,
          fileList: this.fileList,
        }
        await this.player.Native.NodeProxy.setNodeInfo(this.currentNode, {
          code: JSON.stringify(codeInfo),
        })
      }
    },

    closeComponent() {
      this.$emit('closeComponent', 'EngineeringAnimationConfig')
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/style/select';
</style>
<style lang="scss" scoped>
@import '../../assets/style/index';

#EngineeringAnimationConfig {
  background-color: rgba(0, 18, 55, 0.3) !important;
  transition: left 0.3s;
}

.form_body {
  background: rgba(24, 41, 72, 0.5);

  ::v-deep .el-loading-mask {
    background: rgba(24, 41, 72, 0.8) !important;
  }
}
</style>
